<template>
  <div>
    <overview-layout ref="overview" :tableCfg="tableCfg">
      <template slot="AdvancedFilter">
        <b-form ref="form" class="offset-md-1" autocomplete="off">
          <div class="row">
            <detail-field class="col-md-3" label="Contract - Student" field="contract_id" :optionListApiUrl="'/contracts/choice/'" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
            <detail-field class="col-md-3" v-if="isPlanned" label="Planned before" type="date" field="planned_before" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
            <detail-field class="col-md-3" v-if="!isPlanned" label="University y1" field="y1_university_id" :optionListApiUrl="'/universities/choice/'" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
            <detail-field class="col-md-3" v-if="!isPlanned" label="University y2" field="y2_university_id" :optionListApiUrl="'/universities/choice/'" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
            <detail-field class="col-md-3" v-if="!isPlanned" label="Exported after" type="date" field="exported_after" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
            <detail-field class="col-md-3" v-if="!isPlanned" label="Ready for export" field="ready_for_export" :optionList="boolFilterOptions" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
            <detail-field class="col-md-3" label="Type" field="scholarship_payment_type_id" :optionListApiUrl="'/scholarship_payment_types/choice/'" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
            <detail-field class="col-md-3" label="Status" field="contract_status_id" :optionListApiUrl="'/contract_status/choice/'" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
            <detail-field class="col-md-3" label="Intake" field="intake" :optionListApiUrl="'/contracts_intake/choice/'" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
          </div>
        </b-form>
      </template>
      <template slot="ExtraOptions" scope="props">
          <b-dropdown variant="default" size="sm">
            <template slot="button-content"> <i class="fa fa-cog"></i> </template>
            <b-dropdown-item @click="exportSelection('/scholarship_payments/download_report', 'Payments.xlsx')">Export Selection</b-dropdown-item>
            <b-dropdown-item @click="$refs.modalCheckUniversityFeesOk.show()">Check University Fees</b-dropdown-item>
            <b-dropdown-item v-if="isNumbered && privUser" @click="$refs.modalExportPaymentOk.show()">Export Payments</b-dropdown-item>
            <b-dropdown-item v-if="isNumbered && privUser" @click="exportSelection('/scholarship_payments/download_kit_report', 'KIT_Payments.xlsx')">Export KIT Payments</b-dropdown-item>
            <b-dropdown-item v-if="isPlanned && privUser" @click="$refs.modalCreatePaymentOk.show()">Schedule Payments</b-dropdown-item>
          </b-dropdown>
          <b-dropdown v-if="hasSelections() && privAdministrator" variant="default" size="sm">
            <template slot="button-content">
                <i class="fa fa-rocket"></i> Batch
            </template>
            <b-dropdown-item v-if="isPlanned" @click="$refs.modalSchedulePaymentOk.show()">Schedule Payments</b-dropdown-item>
            <b-dropdown-item v-if="isNumbered" @click="$refs.modalBulkEdit.show()">Bulk Edit</b-dropdown-item>
          </b-dropdown>
      </template>
    </overview-layout>
    <b-modal ref="modalExportPaymentOk" title="Export Payments" ok-title="Yes" close-title="No" @ok="exportPayments" >
      Are you sure you want to export these payments?
    </b-modal>
    <b-modal ref="modalSchedulePaymentOk" title="Schedule Payments" ok-title="Yes" close-title="No" @ok="$refs.overview.runBatch(createBatchPayments, 'document_reference')" >
      Are you sure you want to schedule these payments?
    </b-modal>
    <b-modal ref="modalCheckUniversityFeesOk" title="Check University Fees" ok-title="Yes" close-title="No" @ok="checkUniversityFees" >
      Are you sure you want to check the university payments?
      <b-form-fieldset label-text-align="right" label="Period:" horizontal>
        <b-form-input v-model="universityFeePeriod" name="universityFeePeriod" type="text" class="float-right"/>
      </b-form-fieldset>
    </b-modal>
    <b-modal ref="modalCreatePaymentOk" title="Schedule Payments" ok-title="Yes" close-title="No" @ok="createPayments" >
      Are you sure you want to schedule these payments?
    </b-modal>
    <b-modal ref="modalBulkEdit" title="Bulk Edit" ok-title="Apply" close-title="Cancel" @ok="bulkOk('/scholarship_payments/bulk_edit')" >
      <b-form ref="form" class="offset-md-1" autocomplete="off">
        <div class="row">
          <detail-field class="col-md-10" label="Amount" field="amount" :rec="bulkRec" type="money" vvalidate="ok" :validator="validator"/>
        </div>
        <div class="row">
          <detail-field class="col-md-10" label="Payment Date" field="payment_date" :rec="bulkRec" type="date" vvalidate="ok" :validator="validator"/>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import OverviewMixin from '../../components/OverviewMixin'
import FieldDefs from './FieldDefs.js'
function calcUniversityPeriod (dt) {
  const m = dt.getMonth()
  const y = dt.getFullYear()
  var result
  if (m > 7) result = y + '-' + (y + 1) + '/01'
  else if (m < 2) result = (y - 1) + '-' + y + '/01'
  else result = (y - 1) + '-' + y + '/02'
  // console.log(m + 1, result)
  return result
}
export default {
  name: 'invoice_overview',
  mixins: [OverviewMixin],
  data () {
    return {
      tableCfg: FieldDefs,
      universityFeePeriod: calcUniversityPeriod(new Date())
    }
  },
  computed: {
    isNumbered () { return this.tableCfg.subType(this) === 'numbered' },
    isPlanned () { return this.tableCfg.subType(this) === 'planned' }
  },
  methods: {
    exportPayments () {
      this.exportSelection('/scholarship_payments/export_payments', 'ExportPayments.xlsx')
      this.$refs.overview.refreshTable()
    },
    checkUniversityFees () {
      this.api.downloadPost('/scholarship_payments/export_university_fee_payments', {period: this.universityFeePeriod}, 'University_fees.zip')
    },
    createPayments () {
      this.postWithSelection('/scholarship_payments/create_payments', 'Creating Payments', this.$refs.overview.refreshTable)
    },
    createBatchPayments (id, okFnc, errorFnc) {
      this.api.post('/scholarship_payments/' + id + '/create_payment', {}, okFnc, errorFnc, this.$refs.overview.alert)
    }

  }
}
</script>



// WEBPACK FOOTER //
// Overview.vue?5ddd8567